// import { Toast } from 'mint-ui'
import md5 from 'blueimp-md5'
import { getCookie } from '@/utils/common/cookie'
import { storage, pageHashs, whiteList, pageArgs, vconsole_log, decryptAES_H5 } from '@/utils'
import { getAccountId } from '@/utils/init/pubs'
import { v4 as uuidv4 } from 'uuid'
import { saTrack } from '@/utils/common/shence'

// 接口交互携带的Header信息
export function getHeaderUser(data, options) {
    if (data && options) {
        // 为 data 计算 uuid
        if (options.uuid && data.uuid) {
            data.uuid = uuidv4()
        }
    }
    const buildVersion = parseInt(appUser.buildVersion) || new Date().toFormattedString('yyMMdd01') // 默认值
    const timestamp = parseInt(new Date().getTime() / 1000)
        // sign.type/: 1 仅验证时间戳；2 验证请求参数
    const type = pageArgs.args().signType || 1
    const sign = getSign({ buildVersion, timestamp, data, type })
    let miniProgram = {}
    if (appUser.miniProgram) {
        appUser.appName = 'ylsn_web'
        miniProgram = {
            fromChannel: 'WechatMini',
            fromAccountId: 'ylsn_mini'
        }
    }
    return {
        ...(appUser.userId ? { userId: appUser.userId } : {}), // 匿名页面没有用户参数
        ... { accountId: appUser.appName || 'default' }, // 平台标识
        version: appUser.version,
        token: appUser.token,
        channel: appUser.channel,
        buildVersion, // ios 需要的参数
        timestamp,
        deviceId: appUser.deviceId,
        anonymousId: appUser.anonymousId || getCookie('anonymousId'),
        ...sign,
        ...miniProgram
    }
}

// 接口交互时对Data的验证签名
// export function getSign({ buildVersion, timestamp, data, type }) {
//   let sign = ''
//   const salt = 'IN5RA1WTHXLGGX7S02sPQtRWKOSOZEFV'
//   sign = `buildversion=${buildVersion}&timestamp=${timestamp}&salt=${salt}`
//   sign = md5(sign)
//   return {
//     // 为了兼容老版本接口验签 sign,sign505同时存在
//     sign,
//     ...getSign505(data, timestamp)
//   }
// }

export function getSign({ buildVersion, timestamp, data }) {
    // 505强校验:body对象的参数拼接成字符串+salt的值,进行 md5
    // 客户端校验能通过
    // 但是H5端加了个buildVersion参与校验,导致校验不通过
    // 目前来说,大部分接口都是不走该校验方式,不确定哪个接口走 505 校验
    // 2022年06月17日  讲userid拼进去
    let sign = ``
    const salt = 'IOZEFN5X7S0RTHXLGGWKOSA2RPVQDR1W'
    if (!data) data = {}
        // if (appUser && appUser.userId) data.userid = appUser.userId
        // data.timestamp = timestamp
    let keys = Object.keys(data)
        // 排序
    keys = keys.sort()
        // 排除空字段
    keys = keys.filter(key => {
        const value = data[key]
        const type = typeof value
        const isNotObj = type !== 'object' || !(type instanceof Date)
        return isNotObj && value != null && value !== ''
    })
    keys.forEach(key => {
        let value = data[key]
        if (value instanceof Date) value = JSON.stringify(value).replace(/"+/g, '')
        if (value instanceof Array) return
        if (value instanceof Object) return
        sign += `${key}=${value}&`
    })
    sign = `${sign}timestamp=${timestamp}${appUser && appUser.userId ? `&userid=${appUser.userId}` : ''}&salt=${salt}`
  console.log(sign, 1123)
  sign = md5(sign)
  // sign = md5(`${sign}salt=${salt}`)

  return { sign }
}

export function getChannel() {
  var u = navigator.userAgent
  // 检查微信和公众号环境
  const weixin = u.indexOf('MicroMessenger') > -1
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
  var isIpad = u.indexOf('iPad') > -1
  var isOpenHarmony = /OpenHarmony|HUAWEI/i.test(u)

  if (weixin) {
    if (isAndroid) return 'Android'
    if (isiOS) return 'IOS'
    if (isIpad) return 'IPAD'
    if (isOpenHarmony) return 'OPENHARMONY'
    saTrack('other_channel', {
      u
    })
  } else {
    return 'WEB'
  }
  return ''
}

// 单例获取AppUser
function getAppUser(appUser) {
  console.log(window, 'window')
  if (appUser != null) return appUser
  const miniProgram = window.navigator.userAgent.indexOf('miniProgram') > 1

  const android = getCookie('appVersionAndroid')
  const ios = getCookie('appVersioniOS')
  const buildVersion = getCookie('appBuildVersion')
  const iosChannel = getCookie('appChanneliOS')
  let channel = null // 默认
  if (android) channel = iosChannel || 'Android'
  if (ios) channel = iosChannel || 'IOS'
  if (channel == null) {
    channel = getChannel()
  }
  const version = android || ios
  const isNative = Boolean(android || ios || miniProgram)

  appUser = {
    channel,
    buildVersion,
    version,
    isNative,
    miniProgram,
    appStatusBarHeight: getCookie('appStatusBarHeight') || 0,
    anonymousId: getCookie('appDeviceId'),
    isTestEnv:
      process.env.NODE_ENV !== 'production' ||
      location.href.indexOf('ylyk-test.com') > 0 ||
      location.href.indexOf('ylyk.com/test/') > 0
  }

  // 读取APP写入的授权信息
  appUser.getNativeUser = () => {
    const userId = getCookie('appUserId')
    if (userId) {
      appUser.userId = parseInt(userId)
    }
    appUser.token = getCookie('appToken')
    appUser.deviceId = getCookie('appDeviceId')
    appUser.accountId = getCookie('appAccountId')
  }

  // 读取小程序uni.Storage中的用户信息（在H5中读取）
  appUser.getMiniProgramUser = () => {
    if (appUser.miniProgram) {
      try {
        console.log('开始获取小程序用户信息...')
        // 从hash参数获取（如果参数在hash中）
        const hashParams = new URLSearchParams(window.location.hash.split('?')[1] || '')
        const hashToken = hashParams.get('token')
        const hashUserId = hashParams.get('userId')
        if (hashToken && hashUserId) {
          appUser.userId = hashUserId
          appUser.token = hashToken
          return
        }
      } catch (error) {
        console.error('获取小程序用户信息失败', error)
      }
    }
  }

  // 读取原生用户
  appUser.getNativeUser()

  // 读取小程序用户
  appUser.getMiniProgramUser()
  const { accountId } = appUser

  if (appUser.isNative) {
    // logs.initUser(userId, `APP ${version}`)
    appUser.appName = accountId
  }
  // 读取微信环境下缓存的授权信息
  appUser.setWeixin = (isWeixin, userId) => {
    appUser.isWeixin = isWeixin
    appUser.isBrowser = !(isWeixin || appUser.isNative)

    if (!appUser.isNative) {
      appUser.appName = getAccountId()
    }

    // 【浏览器和微信测试】
    if (appUser.isBrowser || userId) {
      //
    } else if (isWeixin) {
      // 读取本地微信用户
      // appUser.channel = 'weixin'
      const wxUser = storage.AppWeixinKey().getItem()
      // 取到本地的微信用户信息
      if (wxUser.openId || wxUser.token) {
        appUser.setWeixinUser(wxUser, 0)
      }
      // logs.initUser(appUser.userId, `Weixin '${appUser.appName}'`)
    }
    // 读取本地用户
    const user = storage.AppUserKey().getItem()
    if (user.token) {
      // 本地调试兼容微信授权的结果
      user.wxFormat ? appUser.setWeixinUser(user, 0) : appUser.setAppUser(user, 0)
    }
    // logs.initUser(appUser.userId, `User '${appUser.appName}'`)
  }
  // 微信授权后更新微信用户信息（无userId后，跳转到登录流程）
  appUser.setWeixinUser = (data, isset) => {
    if (isset !== 0) {
      // 保留code
      data.code = appUser.code = appUser.wxcode
      data.wxFormat = true
      storage.AppWeixinKey().setItem(data) // 存储微信登录用户信息openid等。
    }
    const { unionId, openId, userId, mobileNumber, nickName, token, code, avtarUrl } = data
    appUser.userId = userId
    try {
      appUser.mobileNumber = decryptAES_H5(mobileNumber)
    } catch (e) {
      appUser.mobileNumber = mobileNumber
    }
    appUser.nickName = nickName
    appUser.token = token
    appUser.avtarUrl = avtarUrl
    appUser.code = code // 保留的微信授权使用的code
    if (unionId) appUser.unionId = unionId
    if (openId) appUser.openId = openId
  }
  // 微信授权的code失效后，仅清除code
  appUser.clearWeixinCode = () => {
    const appWeixin = storage.AppWeixinKey()
    const wxUser = appWeixin.getItem()
    delete wxUser.code
    appWeixin.setItem(wxUser)
  }
  // 登录成功后设置用户信息
  appUser.setAppUser = (data, isset) => {
    // const bool = isset !== 0;
    // alert(`更新data${JSON.stringify(data)}--->${isset}----${bool}`)
    return new Promise((resolve, reject) => {
      if (isset !== 0) {
        storage.AppUserKey().setItem(data)
      }
      const { token, userModel } = data
      appUser.token = token
      if (token) {
        const { wxUnionId: unionId, wxOpenId: openId } = userModel || data // 两个结构都有
        appUser.userId = userModel.userID || userModel.userId
        if (unionId) appUser.unionId = unionId
        if (openId) appUser.openId = openId
        try {
          appUser.mobileNumber = decryptAES_H5(userModel.mobileNumber)
        } catch (e) {
          appUser.mobileNumber = userModel.mobileNumber
        }
        appUser.nickName = userModel.nickname
        appUser.avtarUrl = userModel.avtarUrl
        // logs.initUser(userId, `Login Success`)
        resolve(true)
      }
    })
  }
  // 检查有用户
  appUser.hasUser = () => {
    return parseInt(appUser.userId) > 0 && Boolean(appUser.token)
  }
  // 检查有微信授权的用户
  appUser.hasWXUser = () => {
    console.log(appUser, ' appUser.hasWXUser')
    return Boolean(appUser.openId) || Boolean(appUser.token)
  }
  // 清除用户缓存（不清除微信）
  appUser.resetToken = () => {
    storage.AppWeixinKey().remove()
    storage.AppUserKey().remove()
  }
  // 没有用户时，注册或登录账号
  appUser.isNotUserToLogin = (options = {}) => {
    console.log('appUser:', appUser)
    // must 强制登录跳转
    const { hash: _hash, type, action, must } = options

    const hash = _hash || location.hash

    let toLogin
    if (storage.AppUserKeySwitch().getItem().switchPhone) {
      toLogin = true
    } else if (must) {
      toLogin = true
    } else {
      // 暴虐新概念路由不需要用户登录
      if (hash.indexOf('/user_bnxgn_get') >= 0) {
        toLogin = false
      } else {
        toLogin = !appUser.hasUser()
      }
    }
    console.log('是否需要登录:', toLogin, '当前用户', appUser.hasUser(), hash, type, action)
    if (toLogin) {
      // 检查路由是否需要登录
      if (type !== 'button' && whiteList.include()) {
        return
      }
      appUser.showStep({ message: '账号登录(标记登录)' })
      // 跳转到登录页面
      console.log('[Init] no user')
      // 登录页面不记录
      let hash = _hash || location.hash
      const saveHash = hash.indexOf('/login') === -1 && (hash.indexOf('/home') === -1 || action === 'toLogin')
      if (saveHash) {
        hash = hash.replace('#', '')
        storage.loginNextHash().setItem(hash)
        storage.replace(pageHashs.login, { islogin: true })
      }
    } else {
      // 不在登录页停留的
      if (_hash) {
        storage.replace(_hash)
      }
    }
    return { toLogin }
  }

  appUser.showStep = ({ message, action }) => {
    // 标记
    let { _stepIndex: index } = appUser
    index = (index || 0) + 1
    appUser._stepIndex = index
    const show = pageArgs.args().showConsole
    if (show) {
      message = `[STEP ${index}] ${message} (${action})`
      // Toast(message);
      vconsole_log(message)
    }
  }

  return appUser
}
// APP注入的用户信息
export const appUser = getAppUser()